/**
 * The search field shown in the dock received shipments table's action bar.
 */

import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import SearchField from "@amzn/meridian/search-field"
import useDockReceivedFilters from "../../hooks/use-dock-received-filters"

const DockReceivedSearchField = props => {
  const { filters, dispatch } = useDockReceivedFilters()
  const [query, setQuery] = useState("")
  const filterValue = filters.get("id")?.value || ""

  const search = useCallback(
    value =>
      value
        ? dispatch({
            type: "UPDATE_FILTER",
            filter: "allFields",
            value,
            tagLabel: `${value}`,
          })
        : dispatch({
            type: "REMOVE_FILTER",
            filter: "allFields",
          }),
    [dispatch]
  )

  // Debounce calls to onSearch
  useEffect(() => {
    const timeout = setTimeout(() => search(query), 300)
    return () => clearTimeout(timeout)
  }, [query, search])

  useEffect(() => {
    setQuery(filterValue)
  }, [filterValue])

  return (
    <SearchField
      placeholder={
        props.mobile ? "Search" : "Search"
      }
      value={query}
      onChange={setQuery}
      onSubmit={search}
      onClear={search}
      searchButton={true}
      width={props.mobile ? 200 : 360}
    />
  )
}

DockReceivedSearchField.propTypes = {
  mobile: PropTypes.bool,
}

DockReceivedSearchField.defaultProps = {
  mobile: false,
}

export default DockReceivedSearchField
